import React from 'react';
import './RevealMore.css';

/**
 * Patron compartido "desplegar para ver mas": panel recortado con fade +
 * barra clickeable de ancho completo UBICADA DEBAJO del area recortada
 * (fuera del overflow:hidden, nunca se corta). Usado por SegmentCounts
 * (Recovery & onboarding) y RevenueFinder (More opportunities) para que
 * el mecanismo de reveal sea identico en ambos lugares.
 *
 * Props:
 *  - expanded: bool
 *  - onToggle: () => void
 *  - label: string | node — contenido rico del titulo cuando esta colapsado
 *    (ej. "3 more plays · $1,200 more this week"). El caller arma el texto;
 *    RevealMore no genera "Show N more" internamente.
 *  - panelId: string — id estable del panel controlado (aria-controls)
 *  - children: contenido del panel (grid de tarjetas)
 *  - className: clases extra opcionales para el wrapper
 */
export default function RevealMore({
  expanded,
  onToggle,
  label,
  panelId,
  children,
  className = '',
}) {
  return (
    <div className={`reveal-more${className ? ` ${className}` : ''}`}>
      <div
        id={panelId}
        className={`reveal-more-panel${expanded ? ' reveal-more-panel--open' : ' reveal-more-panel--collapsed'}`}
      >
        <div aria-hidden={!expanded || undefined} inert={!expanded ? true : undefined}>
          {children}
        </div>

        {!expanded && <div className="reveal-more-fade" />}
      </div>

      <button
        type="button"
        className="reveal-more-bar"
        aria-expanded={expanded}
        aria-controls={panelId}
        onClick={onToggle}
      >
        {expanded ? (
          <>Show less <span className="reveal-more-chevron reveal-more-chevron--open">▾</span></>
        ) : (
          <>{label} <span className="reveal-more-chevron">▾</span></>
        )}
      </button>
    </div>
  );
}
